import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { isAuthenticated, isAuthorized } from "@kdose/ng-auth";
import { NextaCanDeactivateCrudForm } from "../shared/nexta-crud/nexta-can-deactivate.guard";
import { UserFormComponent } from "./user-form.component";
import { UserListComponent } from "./user-list.component";

const userRoutes: Routes = [
	{
		path: "benutzer",
		component: UserListComponent,
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
	{
		path: "benutzer/neu",
		component: UserFormComponent,
		canDeactivate: [NextaCanDeactivateCrudForm],
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
	{
		path: "benutzer/:id",
		component: UserFormComponent,
		canDeactivate: [NextaCanDeactivateCrudForm],
		canActivate: [isAuthenticated, isAuthorized],
		data: {
			requiredAuthorizations: {
				oneOf: ["ADMIN"],
			},
		},
	},
];
@NgModule({
	imports: [RouterModule.forChild(userRoutes)],
	exports: [RouterModule],
})
export class UserRoutingModule {}
